import axios from "axios";

/**
 * API client for user-scoped Spendings CSV extract flow.
 *
 * Proxy routes (compta-app/routes/spendings.js) forward to Go backend v2:
 *   GET /spendings/extract                     -> starts async CSV build, returns { processID }
 *   GET /spendings/extract/status/:processID   -> returns { status, total, actual }
 *   GET /spendings/extract/download/:processID -> returns CSV blob
 *
 * Auth headers (Authorization, UserID, UserType) are already set globally by setAuthToken.js.
 */

/**
 * Serializes params with array values as repeated keys, consistent with the
 * Go backend's expectations for `whereQuery` and `fields` parameters.
 * e.g. { whereQuery: ["a", "b"] } -> "whereQuery=a&whereQuery=b"
 */
const extractParamsSerializer = (params) => {
    const search = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
        const value = params[key];
        if (value === undefined || value === null || value === "") return;
        if (Array.isArray(value)) {
            value.forEach((v) => {
                if (v !== undefined && v !== null && v !== "") {
                    search.append(key, v);
                }
            });
        } else {
            search.append(key, value);
        }
    });
    return search.toString();
};

export const startExtractSpendingsUserAPI = (params) =>
    axios.get("/spendings/extract", {
        params,
        paramsSerializer: extractParamsSerializer,
    });

export const getExtractStatusAPI = (processID) =>
    axios.get(`/spendings/extract/status/${processID}`);

export const downloadExtractAPI = (processID) =>
    axios.get(`/spendings/extract/download/${processID}`, {
        responseType: "blob",
    });
